import { render, staticRenderFns } from "./Prescription.vue?vue&type=template&id=3a9ba019&scoped=true&"
import script from "./Prescription.vue?vue&type=script&lang=js&"
export * from "./Prescription.vue?vue&type=script&lang=js&"
import style0 from "./Prescription.vue?vue&type=style&index=0&id=3a9ba019&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9ba019",
  null
  
)

export default component.exports